import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ed29806"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "courses" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 center mb-4" }, "Kurser", -1))
const _hoisted_3 = { class: "courseContainer" }
const _hoisted_4 = { class: "layout gutter--lg" }
const _hoisted_5 = { class: "row justify--space-between align--center" }
const _hoisted_6 = { class: "md2 flex" }
const _hoisted_7 = { class: "md3 flex" }
const _hoisted_8 = { class: "va-table-responsive" }
const _hoisted_9 = {
  class: "va-table va-table--clickable va-table--hoverable coursesTable",
  style: {"width":"100%"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Pris", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Muligheder", -1))
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "center mobile" }
const _hoisted_14 = { class: "capitalize" }
const _hoisted_15 = { class: "center" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Tilmeld")
const _hoisted_17 = {
  key: 0,
  class: "row justify--center align--baseline paginationControls"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_19 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_20 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_22 = { class: "selectPageSize" }
const _hoisted_23 = { class: "display-4 center" }
const _hoisted_24 = { class: "courseDetailsContainer" }
const _hoisted_25 = { class: "mainArea" }
const _hoisted_26 = { class: "sideArea" }
const _hoisted_27 = {
  key: 0,
  class: "documents mb-2"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 center mb-2" }, "Dokumenter", -1))
const _hoisted_29 = { class: "center" }
const _hoisted_30 = ["href"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "DOKUMENTER", -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "timeAndPlace mb-2" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 center mb-2" }, "Tid, sted & pris", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fra: ", -1))
const _hoisted_36 = { class: "capitalize" }
const _hoisted_37 = /*#__PURE__*/_createTextVNode()
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "kl.", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Til: ", -1))
const _hoisted_40 = { class: "capitalize" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Sidste tilmeldingsfrist: ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Sted: ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Pris: ", -1))
const _hoisted_44 = { class: "organizer mb-2" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 center mb-2" }, "Arrangørinfo", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Arrangør: ", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Telefon: ", -1))
const _hoisted_48 = ["href"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Email: ", -1))
const _hoisted_50 = ["href"]
const _hoisted_51 = {
  key: 1,
  class: "signUp mb-2"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 center mb-2" }, "Tilmelding", -1))
const _hoisted_53 = { key: 0 }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Telefon: ", -1))
const _hoisted_55 = /*#__PURE__*/_createTextVNode()
const _hoisted_56 = ["href"]
const _hoisted_57 = { key: 1 }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Email: ", -1))
const _hoisted_59 = ["href"]
const _hoisted_60 = {
  key: 2,
  class: "row justify--center mt-2"
}
const _hoisted_61 = { class: "flex" }
const _hoisted_62 = { class: "row justify--center align--center" }
const _hoisted_63 = { class: "flex" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_65 = { class: "display-5 center" }
const _hoisted_66 = { class: "layout gutter--xl" }
const _hoisted_67 = { class: "row justify--center" }
const _hoisted_68 = { class: "flex" }
const _hoisted_69 = {
  key: 0,
  class: "row justify--center align--center"
}
const _hoisted_70 = { class: "flex md6" }
const _hoisted_71 = { class: "flex md6" }
const _hoisted_72 = /*#__PURE__*/_createTextVNode("Tilmeld medlem")
const _hoisted_73 = { class: "layout gutter--xl" }
const _hoisted_74 = { class: "row justify--center" }
const _hoisted_75 = /*#__PURE__*/_createTextVNode("Forsæt")
const _hoisted_76 = { class: "center" }
const _hoisted_77 = { class: "layout gutter--xl" }
const _hoisted_78 = { class: "row justify--center" }
const _hoisted_79 = /*#__PURE__*/_createTextVNode("Forsæt")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_it_modal = _resolveComponent("it-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_button, {
              class: "btn",
              color: "primary",
              rounded: false,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.columnSort('reset')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, {
                  class: "reset",
                  name: "autorenew"
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_select, {
              label: "Kursus status",
              modelValue: _ctx.filterByTimeValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterByTimeValue) = $event)),
              options: _ctx.filterByTimeOptions,
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_va_divider),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.columnSort('courseName')))
                }, "Kursusnavn"),
                _createElementVNode("th", {
                  class: "sorting center mobile",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.columnSort('registrationDeadline')))
                }, "Sidste tilmelding"),
                _createElementVNode("th", {
                  class: "sorting",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.columnSort('courseDate')))
                }, "Afholdes"),
                _hoisted_10,
                _hoisted_11
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", {
                    class: "clickAble",
                    onClick: ($event: any) => (_ctx.viewCourse(course.id))
                  }, _toDisplayString(course.event_titel), 9, _hoisted_12),
                  _createElementVNode("td", _hoisted_13, _toDisplayString((course.event_sidstetilmelding === null ? _ctx.danishDateString(course.event_start) : _ctx.danishDateString(course.event_sidstetilmelding))), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.beingHeld(course.event_start, course.event_slut)), 1),
                  _createElementVNode("td", null, _toDisplayString(course.event_pris), 1),
                  _createElementVNode("td", _hoisted_15, [
                    (_ctx.canSignUp(course.event_sidstetilmelding === null ? course.event_start : course.event_sidstetilmelding))
                      ? (_openBlock(), _createBlock(_component_va_button, {
                          key: 0,
                          size: "small",
                          class: "btn",
                          color: "success",
                          rounded: false,
                          onClick: ($event: any) => (_ctx.signUp(course.id))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ])
        ]),
        (_ctx.filterByTimeValue !== 'Kommende kurser')
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_va_button, {
                icon: "first_page",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.jumpToPage(1)))
              }),
              _createVNode(_component_va_button, {
                icon: "keyboard_double_arrow_left",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.turnToNewPage(-5)))
              }),
              _createVNode(_component_va_button, {
                icon: "chevron_left",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.turnToNewPage(-1)))
              }),
              _hoisted_18,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.currentPage) = $event)),
                onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => (_ctx.jumpToPage(this.currentPage)), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.currentPage]
              ]),
              (_ctx.totalNumberOfPages === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_19, " af " + _toDisplayString(_ctx.totalNumberOfPages+1), 1))
                : (_openBlock(), _createElementBlock("p", _hoisted_20, " af " + _toDisplayString(_ctx.totalNumberOfPages), 1)),
              _createVNode(_component_va_button, {
                icon: "chevron_right",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.turnToNewPage(1)))
              }),
              _createVNode(_component_va_button, {
                icon: "keyboard_double_arrow_right",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.turnToNewPage(5)))
              }),
              _createVNode(_component_va_button, {
                icon: "last_page",
                class: "mr-2",
                size: "small",
                rounded: false,
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.jumpToPage(this.totalNumberOfPages)))
              }),
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_va_select, {
                  class: "mr-2",
                  modelValue: _ctx.pageSizeValueString,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.pageSizeValueString) = $event)),
                  options: _ctx.pageSizeOptions,
                  bordered: ""
                }, null, 8, ["modelValue", "options"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.courseDetailsModal,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.courseDetailsModal) = $event)),
      width: "50%"
    }, {
      header: _withCtx(() => [
        _createElementVNode("h4", _hoisted_23, _toDisplayString(_ctx.courseDetails.title), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.courseDetails.description) = $event)),
              class: "description",
              readonly: ""
            }, null, 512), [
              [_vModelText, _ctx.courseDetails.description]
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            (_ctx.courseDetails.documents.length > 0 && _ctx.courseDetails.documents !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("p", _hoisted_29, [
                    _createElementVNode("a", {
                      href: _ctx.defaultURL + _ctx.courseDetails.documents[0].url,
                      target: "_blank"
                    }, _hoisted_32, 8, _hoisted_30)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("p", null, [
                _hoisted_35,
                _createElementVNode("span", _hoisted_36, _toDisplayString((_ctx.courseDetails.start !== null && _ctx.courseDetails.start.length >= 1 ? _ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(_ctx.courseDetails.start)) : '-')), 1),
                _hoisted_37,
                _hoisted_38,
                _createTextVNode(" " + _toDisplayString(_ctx.getClockFromDateString(_ctx.courseDetails.start)), 1)
              ]),
              _createElementVNode("p", null, [
                _hoisted_39,
                _createElementVNode("span", _hoisted_40, _toDisplayString((_ctx.courseDetails.end !== null && _ctx.courseDetails.end.length >= 1 ? _ctx.danishDataWClock(_ctx.locConvertFromUTCtoLocalDateTime(_ctx.courseDetails.end)) : '-')), 1)
              ]),
              _createElementVNode("p", null, [
                _hoisted_41,
                _createElementVNode("span", null, _toDisplayString(_ctx.danishDateString(_ctx.courseDetails.registrationDeadline)), 1)
              ]),
              _createElementVNode("p", null, [
                _hoisted_42,
                _createTextVNode(_toDisplayString(_ctx.courseDetails.place), 1)
              ]),
              _createElementVNode("p", null, [
                _hoisted_43,
                _createTextVNode(_toDisplayString(_ctx.priceToString(_ctx.courseDetails.price) + ' kr.'), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("p", null, [
                _hoisted_46,
                _createTextVNode(_toDisplayString(_ctx.courseDetails.clubName), 1)
              ]),
              _createElementVNode("p", null, [
                _hoisted_47,
                _createElementVNode("a", {
                  href: 'tel:' + _ctx.courseDetails.clubTelephone
                }, _toDisplayString(_ctx.courseDetails.clubTelephone), 9, _hoisted_48)
              ]),
              _createElementVNode("p", null, [
                _hoisted_49,
                _createElementVNode("a", {
                  href: 'mailto:' + _ctx.courseDetails.clubEmail
                }, _toDisplayString(_ctx.courseDetails.clubEmail), 9, _hoisted_50)
              ])
            ]),
            (_ctx.extraInfoPresent(_ctx.courseDetails.extraContactMail) || _ctx.extraInfoPresent(_ctx.courseDetails.extraContactTelephone) || _ctx.todaysDate <= _ctx.courseDetails.registrationDeadline)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _hoisted_52,
                  (_ctx.extraInfoPresent(_ctx.courseDetails.extraContactTelephone))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_53, [
                        _hoisted_54,
                        _hoisted_55,
                        _createElementVNode("a", {
                          href: 'tel:' + _ctx.courseDetails.extraContactTelephone
                        }, _toDisplayString(_ctx.courseDetails.extraContactTelephone), 9, _hoisted_56)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.extraInfoPresent(_ctx.courseDetails.extraContactMail))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_57, [
                        _hoisted_58,
                        _createElementVNode("a", {
                          href: 'mailto:' + _ctx.courseDetails.extraContactMail
                        }, _toDisplayString(_ctx.courseDetails.extraContactMail), 9, _hoisted_59)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.todaysDate <=_ctx.courseDetails.registrationDeadline)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createVNode(_component_va_button, {
                            color: "success",
                            size: "small",
                            rounded: false,
                            onClick: _cache[15] || (_cache[15] = ($event: any) => {_ctx.courseDetailsModal = false; _ctx.signUpModal = true})
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString((_ctx.memberRights === _ctx.clubManagerId ? 'Tilmeld medlem' : 'Tilmeld')), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", _hoisted_63, [
            _createVNode(_component_va_button, {
              class: "btn",
              color: "secondary",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.courseDetailsModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_64
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.signUpModal,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.signUpModal) = $event))
    }, _createSlots({
      header: _withCtx(() => [
        _createElementVNode("h5", _hoisted_65, "Tilmelding til " + _toDisplayString(_ctx.courseInfo.event_titel), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("p", null, "Det koster " + _toDisplayString(_ctx.courseInfo.event_pris) + " at melde dig til " + _toDisplayString(_ctx.courseInfo.event_titel), 1)
            ])
          ]),
          (_ctx.memberRights === _ctx.clubManagerId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, [
                  _createVNode(_component_va_select, {
                    modelValue: _ctx.clubMemberValue,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.clubMemberValue) = $event)),
                    options: _ctx.clubMemberOptions,
                    "text-by": (v) => v.memberName,
                    "track-by": (v) => v.memberId,
                    bordered: "",
                    label: "Tilmeld medlem",
                    searchable: ""
                  }, null, 8, ["modelValue", "options", "text-by", "track-by"])
                ]),
                _createElementVNode("div", _hoisted_71, [
                  _createVNode(_component_va_button, {
                    size: "small",
                    color: "success",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.registerMember()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_72
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, [
      (_ctx.memberRights === _ctx.clubManagerId)
        ? {
            name: "actions",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  _createVNode(_component_va_button, {
                    class: "mr-4",
                    color: "success",
                    onClick: _cache[20] || (_cache[20] = ($event: any) => ((_ctx.courseInfo.event_pris > 0 && _ctx.courseInfo.produkt_id !== null) ? _ctx.toCheckOut() : _ctx.signUpModal = false))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString((_ctx.courseInfo.event_pris > 0 && _ctx.courseInfo.produkt_id !== null) ? 'Til kassen' : 'Forsæt'), 1)
                    ]),
                    _: 1
                  }),
                  (_ctx.courseInfo.event_pris > 0 && _ctx.courseInfo.produkt_id !== null)
                    ? (_openBlock(), _createBlock(_component_va_button, {
                        key: 0,
                        class: "ml-4",
                        color: "secondary",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.signUpModal = false))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_75
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          }
        : {
            name: "actions",
            fn: _withCtx(() => [
              _createElementVNode("div", { class: "layout gutter--xl" }, [
                _createElementVNode("div", { class: "row justify--center" }, [
                  _createVNode(_component_va_button, {
                    class: "mr-4",
                    color: "success",
                    onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.registerYourSelf()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString((_ctx.courseInfo.event_pris > 0 && _ctx.courseInfo.produkt_id !== null) ? 'Køb nu' : 'Tilmeld nu'), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_va_button, {
                    class: "ml-4",
                    color: "secondary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Annuller")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          }
    ]), 1032, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.successSignedUpModal,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.successSignedUpModal) = $event))
    }, {
      body: _withCtx(() => [
        _createElementVNode("p", _hoisted_76, _toDisplayString(_ctx.signUpFree ? 'Du er blevet tilmeldt' : 'Din tilmelding er blevet tilføjet til kurven'), 1)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_77, [
          _createElementVNode("div", _hoisted_78, [
            _createVNode(_component_va_button, {
              class: "mr-4",
              color: "success",
              onClick: _cache[24] || (_cache[24] = ($event: any) => ((_ctx.signUpFree ? _ctx.successSignedUpModal = false : _ctx.toCheckOut())))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.signUpFree ? 'Forsæt' : 'Til kassen'), 1)
              ]),
              _: 1
            }),
            (!_ctx.signUp)
              ? (_openBlock(), _createBlock(_component_va_button, {
                  key: 0,
                  class: "ml-4",
                  color: "secondary",
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.successSignedUpModal = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_79
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}